import { useTranslation } from 'react-i18next'
import { Platform, ScrollView, View } from 'react-native'
import { router } from 'expo-router'
import ButtonsFixed from '@ui/buttons/ButtonsFixed'
import useIntroStore from 'hooks/useIntroStore'
import { useStaff } from 'hooks/useSession'

import Header from './Header'
import Consultant from './sections/Consultant'
import Deals from './sections/Deals'

export default function IntroAvatar() {
  const { t } = useTranslation(['ui'])
  const { toggleMode } = useIntroStore()
  const staff = useStaff()

  const toggleConsultant = () => {
    if (staff) {
      router.navigate('/staff/panel')
      return
    }
    toggleMode('staff', { redirect: '/staff/panel' })
  }
  return (
    <>
      <ScrollView
        className="h-full w-full bg-white"
        contentContainerClassName="flex w-full"
      >
        <Header />
        <View className="gap-8 px-8">
          <Consultant onPress={toggleConsultant} />
          <Deals />
        </View>
      </ScrollView>
      {Platform.OS === 'web' && (
        <ButtonsFixed
          buttons={[
            {
              variant: 'filled',
              label: t('ui:startGuidance'),
              onPress: toggleConsultant,
            },
          ]}
        />
      )}
    </>
  )
}
